/**
 * ✅ Cloudflare Worker経由で動画変換をリクエスト
 * @param key アップロードされた動画のキー（S3パス相当）
 * @returns 署名付き再生URL（CloudFront経由） or 出力先パス
 */
export const requestVideoConversion = async (key: string): Promise<string> => {
  const res = await fetch(
    "https://cf-worker-upload.ik39-10vevic.workers.dev/convert-video",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key }),
    }
  );

  const data: {
    jobId?: string;
    outputPath?: string;
    playbackUrl?: string;
    error?: string;
  } = await res.json();

  if (!res.ok || !data.playbackUrl) {
    throw new Error(data.error || "変換ジョブ作成に失敗しました");
  }

  return data.playbackUrl;
};

/**
 * ✅ Cloudflare Worker経由で署名付きURLを取得
 * @param path playlist.m3u8までのS3パス（例: converted/動画ID/ファイル名/playlist.m3u8）
 * @returns 署名付き再生URL
 */
export const fetchSignedUrl = async (path: string): Promise<string> => {
  const res = await fetch(
    "https://cf-worker-upload.ik39-10vevic.workers.dev/signed-url",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path }),
    }
  );
  const data = await res.json();
  if (!res.ok || !data.signedUrl) {
    throw new Error("署名付きURLの取得に失敗しました");
  }
  return data.signedUrl;
};

/**
 * ✅ Cloudflare Worker経由で署名付きCookieを取得（「body stream already read」エラー完全回避版）
 * @param path playlist.m3u8までのS3パス（例: converted/動画ID/ファイル名/playlist.m3u8）
 * @returns { cookies: Record<string, string> }
 */
export const fetchSignedCookie = async (path: string): Promise<{ cookies: Record<string, string> }> => {
  const res = await fetch(
    "https://cf-worker-upload.ik39-10vevic.workers.dev/signed-cookie",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // Cookieを確実にセット
      body: JSON.stringify({ path }),
    }
  );
  let data: any = {};
  try {
    data = await res.json();
  } catch {}
  if (!res.ok || !data.cookies) {
    throw new Error("署名付きCookie取得に失敗: " + (data?.error || res.statusText));
  }
  return { cookies: data.cookies };
};
